export function validateBankAccount(v) {
    if (!v) return "กรุณาระบุเลขบัญชี";
  
    if (!/^\d+$/.test(v)) {
      return "เลขบัญชีต้องเป็นตัวเลขเท่านั้น";
    }
  
    if (v.length < 10 || v.length > 12) {
      return "เลขบัญชีต้องมีความยาว 10–12 หลัก";
    }
  
    return true;
  }

const registerPaymentErrorMessagesTh = {
  "AUTHORIZED_NAME MUST NOT EXCEED 50 CHARACTERS":
    "ชื่อผู้มีอำนาจลงนามต้องไม่เกิน 50 ตัวอักษร",
  "AUTHORIZED_POSITION MUST NOT EXCEED 50 CHARACTERS":
    "ตำแหน่งผู้มีอำนาจลงนามต้องไม่เกิน 50 ตัวอักษร",
  "BANK_ACCOUNT_NAME MUST NOT EXCEED 50 CHARACTERS":
    "ชื่อบัญชีธนาคารต้องไม่เกิน 50 ตัวอักษร",
  "ADMIN_NAME MUST NOT EXCEED 50 CHARACTERS":
    "ชื่อผู้ติดต่อประสานงานต้องไม่เกิน 50 ตัวอักษร",
  "FINANCIAL_NAME MUST NOT EXCEED 50 CHARACTERS":
    "ชื่อผู้ติดตามการเงิน/บัญชีต้องไม่เกิน 50 ตัวอักษร",
  "ADMIN_EMAIL MUST NOT EXCEED 50 CHARACTERS":
    "อีเมลผู้ติดต่อประสานงานต้องไม่เกิน 50 ตัวอักษร",
  "FINANCIAL_EMAIL MUST NOT EXCEED 50 CHARACTERS":
    "อีเมลผู้ติดตามการเงิน/บัญชีต้องไม่เกิน 50 ตัวอักษร",
  "TECHNICAL_EMAIL MUST NOT EXCEED 50 CHARACTERS":
    "อีเมลฝ่ายเทคนิคต้องไม่เกิน 50 ตัวอักษร",
};

function extractRegisterPaymentErrorMessage(error) {
  if (!error) return "";
  if (typeof error === "string") return error;
  if (typeof error.message === "string") return error.message;
  if (typeof error.data === "string") return error.data;
  if (typeof error.message?.message === "string") {
    return error.message.message;
  }
  if (typeof error.data?.message === "string") {
    return error.data.message;
  }
  return "";
}

export function translateRegisterPaymentErrorMessage(message) {
  if (!message || typeof message !== "string") return message;
  const normalizedMessage = message.trim().toUpperCase();
  return registerPaymentErrorMessagesTh[normalizedMessage] || message;
}

export function normalizeRegisterPaymentError(error) {
  const serverMessage = extractRegisterPaymentErrorMessage(error);
  const translatedMessage = translateRegisterPaymentErrorMessage(serverMessage);

  if (!serverMessage || translatedMessage === serverMessage) {
    return error;
  }

  if (error && typeof error === "object") {
    return {
      ...error,
      message: translatedMessage,
      original_message: serverMessage,
    };
  }

  return {
    message: translatedMessage,
    original_message: serverMessage,
  };
}
  
